// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"eecd3929","78":"419e03bf","289":"bb5d180f","632":"fe513fa5"}[chunkId] + ".chunk.js";
};